import notify from 'devextreme/ui/notify';

interface IPosition {
     my?: string; //'left'|'center'|'right';
     at?: string; //'left'|'center'|'right';
     of?: string
}
interface INotifyProps {
  message:string;
  position?: IPosition;
  closeOnClick?:boolean,
  closeOnOutsideClick?:boolean
}
type NotifyType = 'error'|'warning'|'success'|'default'

export const showError = (message:string, displayTime = 4000, position: IPosition = { at: 'center' }) => {
  wNotify({ message, position }, 'error', displayTime);
};
export const showWarning = (message:string, displayTime = 4000, position: IPosition = { at: 'center' }) => {
  wNotify({ message, position }, 'warning', displayTime);
};
export const showSuccess = (message:string, displayTime = 3000) => {
  wNotify({ message }, 'success', displayTime);
};


export const wNotify = ({
  message,
  position = { at: 'center' },
  closeOnClick = true,
  closeOnOutsideClick = true
}:INotifyProps, mtype:NotifyType = 'default', displayTime = 3000) => {
  notify({
    message,
    position,
    shading: false,
    closeOnClick,
    closeOnOutsideClick
  },
  mtype,
  displayTime);
};
